import { render, staticRenderFns } from "./PlgBrand.vue?vue&type=template&id=0b952fc5&scoped=true&"
import script from "./PlgBrand.vue?vue&type=script&lang=js&"
export * from "./PlgBrand.vue?vue&type=script&lang=js&"
import style0 from "./PlgBrand.vue?vue&type=style&index=0&id=0b952fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b952fc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b952fc5')) {
      api.createRecord('0b952fc5', component.options)
    } else {
      api.reload('0b952fc5', component.options)
    }
    module.hot.accept("./PlgBrand.vue?vue&type=template&id=0b952fc5&scoped=true&", function () {
      api.rerender('0b952fc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PlgBrand.vue"
export default component.exports